import { AiOutlineInstagram } from 'react-icons/ai';
import { FaWhatsapp } from "react-icons/fa6";
import { FaTiktok } from 'react-icons/fa';

const data = [
  { id: 1, link: 'https://www.instagram.com/itechservice.id/', icon: <AiOutlineInstagram /> },
  { id: 3, link: 'https://www.tiktok.com/@itechservice.id', icon: <FaTiktok /> },
  { id: 6, link: 'https://www.tiktok.com/@itechservice.id', icon: <FaWhatsapp /> },
];

export default data;
